import { 
  GAME_FACT_START,

  GAME_FACT_BASKET_COMMENT, 
  GAME_FACT_BASKET_FAULT, 
  GAME_FACT_BASKET_FREETHROW, 
  GAME_FACT_BASKET_STOP, 
  GAME_FACT_BASKET_TECHNICAL, 
  GAME_FACT_BASKET_THREEPOINTS, 
  GAME_FACT_BASKET_TIMEOUT, 
  GAME_FACT_BASKET_TWOPOINTS, 
  GAME_FACT_BASKET_REPLACEMENT,

  GAME_FACT_COMMENT, 
  GAME_FACT_DROP, 
  GAME_FACT_ESSAI, 
  GAME_FACT_FAULT, 
  GAME_FACT_PENALITE,
  GAME_FACT_TRANSFORMATION, 
  GAME_FACT_YELLOWCARD, 
  GAME_FACT_REDCARD, 
  GAME_FACT_REPLACEMENT, 
  GAME_FACT_SHOOTOUTPENALTY, 
  GAME_FACT_RUGBY_STOP, 
  GAME_FACT_RUGBY_STAR,
  
  GAME_FACT_SOCCER_BUT, 
  GAME_FACT_SOCCER_COMMENT, 
  GAME_FACT_SOCCER_FAULT, 
  GAME_FACT_SOCCER_PENALTY, 
  GAME_FACT_SOCCER_REDCARD, 
  GAME_FACT_SOCCER_REPLACEMENT, 
  GAME_FACT_SOCCER_SHOOTOUTPENALTY, 
  GAME_FACT_SOCCER_SHOT, 
  GAME_FACT_SOCCER_YELLOWCARD, 
  GAME_FACT_SOCCER_STOP,
  GAME_FACT_SOCCER_STAR,

  GAME_FACT_HANDBALL_COMMENT, 
  GAME_FACT_HANDBALL_GOAL, 
  GAME_FACT_HANDBALL_PENALTY, 
  GAME_FACT_HANDBALL_REDCARD, 
  GAME_FACT_HANDBALL_STOP, 
  GAME_FACT_HANDBALL_TIMEOUT, 
  GAME_FACT_HANDBALL_TURNOVER,
  GAME_FACT_HANDBALL_TWOMIN_SUSPENSION, 
  GAME_FACT_HANDBALL_YELLOWCARD,
  GAME_FACT_HANDBALL_REPLACEMENT,
  GAME_FACT_HANDBALL_SHOOTOUT,
   
  reasonListBasketStop, 
  reasonListRugby, 
  reasonListRugbyReplacement, 
  reasonListRugbyStop, 
  reasonListSoccer, 
  reasonListSoccerRedCard, 
  reasonListSoccerStop, 
  typeShotListSoccer,
  reasonListHandballStop, 
  reasonListHandballPenalty, 
  reasonListHandballYellowCard, 
  reasonListHandballRedCard, 
  reasonListHandballTwoMinSuspension, 
  reasonListHandballTurnover,

} from './constants.js'

//IMAGES
import essai from '../../../images/game-fact/buttons/rugby/bouton_essai.png'
import transformation from '../../../images/game-fact/buttons/rugby/bouton_transformation.png'
import drop from '../../../images/game-fact/buttons/rugby/bouton_drop.png'
import penalite from '../../../images/game-fact/buttons/rugby/bouton_penalite.png'
import btn_rugby_tiraubut from '../../../images/game-fact/buttons/rugby/btn_tir_au_but_rugby.png'

import changement from '../../../images/game-fact/buttons/bouton_changement.png'
import commentaire from '../../../images/game-fact/buttons/bouton_commentaire.png'
import yellowcard from '../../../images/game-fact/buttons/bouton_cartonjaune.png'
import redcard from '../../../images/game-fact/buttons/bouton_cartonrouge.png'
import fault from '../../../images/game-fact/buttons/bouton_faute.png'
import btn_star from '../../../images/game-fact/buttons/bouton_star.png'

import tir from '../../../images/game-fact/buttons/soccer/bouton_tir.png'
import but from '../../../images/game-fact/buttons/soccer/bouton_but.png'
import penalty from '../../../images/game-fact/buttons/soccer/bouton_penalty.png'
import btn_soccer_tiraubut from '../../../images/game-fact/buttons/soccer/btn_tir_au_but_foot.png'

import btn_basket_technique from '../../../images/game-fact/buttons/basket/btn_fautes_technique_basket.png'
import btn_basket_lancerfranc from '../../../images/game-fact/buttons/basket/btn_lancer_franc_basket_reussis.png'
import btn_basket_deuxpoints from '../../../images/game-fact/buttons/basket/btn_lancer_franc_basket_2_pt_reussis.png'
import btn_basket_troispoints from '../../../images/game-fact/buttons/basket/btn_lancer_franc_basket_3_pt_reussis.png'
import btn_basket_deuxpoints_generic from '../../../images/game-fact/buttons/basket/btn_lancer_franc_2pts_basket.png'
import btn_basket_troispoints_generic from '../../../images/game-fact/buttons/basket/btn_lancer_franc_3pts_basket.png'
import btn_basket_lancerfranc_generic from '../../../images/game-fact/buttons/basket/btn_lancer_franc_basket.png'
import btn_basket_faute from '../../../images/game-fact/buttons/basket/btn_faute_basket.png'
import btn_basket_timeout from '../../../images/game-fact/buttons/basket/btn_temps_mort_basket.png'


import btn_suspension_handball from '../../../images/game-fact/buttons/handball/btn_exclusion_hand.png'
import btn_timeout_handball from '../../../images/game-fact/buttons/handball/btn_temps_mort_hand.png'
import btn_turnover_handball from '../../../images/game-fact/buttons/handball/btn_balle_perdue_hand.png'
import btn_avertissement_handball from '../../../images/game-fact/buttons/handball/btn_avertissement_hand.png'
import btn_but_hand from '../../../images/game-fact/buttons/handball/btn_but_hand.png'
import btn_but_refuse_hand from '../../../images/game-fact/buttons/handball/btn_but_refuse_hand.png'
import btn_penalty_hand from '../../../images/game-fact/buttons/handball/btn_penalty_hand.png'
import btn_penalty_rate_hand from '../../../images/game-fact/buttons/handball/btn_penalty_rate_hand.png'
import btn_penalty_reussi_hand from '../../../images/game-fact/buttons/handball/btn_penalty_reussi_hand.png'
import btn_disqualification_hand from '../../../images/game-fact/buttons/handball/btn_disqualification_hand.png'
import btn_tir_au_but_hand from '../../../images/game-fact/buttons/handball/btn_tir_au_but_hand.png'
import btn_tir_au_but_rate_hand from '../../../images/game-fact/buttons/handball/btn_tir_au_but_rate_hand.png'
import btn_tir_au_but_reussi_hand from '../../../images/game-fact/buttons/handball/btn_tir_au_but_reussi_hand.png'

// GENERIC
import SelectPlayerInTeam from './generic/SelectPlayerInTeam.js';
import SelectTimer from './generic/SelectTimer.js';
import SelectTeam from './generic/SelectTeam.js';
import SelectYesNo from './generic/SelectYesNo.js';
import SelectComment from "./generic/SelectComment.js";
import SelectReason from "./generic/SelectReason.js";
import SelectPlayerInOtherTeam from './generic/SelectPlayerInOtherTeam.js'

// RECAP
import RecapStart from './recapGeneric/RecapStart.js'

// RUGBY
import RecapEssai from "./rugby/RecapEssai.js";
import RecapTransformation from "./rugby/RecapTransformation.js";
import RecapDrop from "./rugby/RecapDrop.js";
import RecapPenality from "./rugby/RecapPenality.js";
import RecapYellowCard from "./rugby/RecapYellowCard.js";
import RecapRedCard from "./rugby/RecapRedCard.js";
import RecapFault from "./rugby/RecapFault.js";
import RecapReplacement from "./rugby/RecapReplacement.js";
import RecapComment from "./rugby/RecapComment.js";
import RecapRugbyStop from './rugby/RecapRugbyStop.js'
import RecapShootoutPenality from './rugby/RecapShootoutPenality.js'
import RecapRugbyStar from './rugby/RecapRugbyStar.js'

// SOCCER
import RecapSoccerBut from './soccer/RecapSoccerBut.js'
import RecapSoccerPenalty from './soccer/RecapSoccerPenalty.js'
import RecapSoccerFault from './soccer/RecapSoccerFault.js'
import RecapSoccerStop from './soccer/RecapSoccerStop.js'
import RecapSoccerShot from './soccer/RecapSoccerShot.js'
import RecapSoccerShootoutPenalty from './soccer/RecapSoccerShootoutPenalty.js'
import RecapSoccerYellowCard from './soccer/RecapSoccerYellowCard.js'
import RecapSoccerRedCard from './soccer/RecapSoccerRedCard.js'
import RecapSoccerReplacement from './soccer/RecapSoccerReplacement.js'
import RecapSoccerComment from './soccer/RecapSoccerComment.js'
import RecapSoccerStar from './soccer/RecapSoccerStar.js'

// BASKET
import RecapBasketStop from './basket/RecapBasketStop.js'
import RecapBasketComment from './basket/RecapBasketComment.js'
import RecapBasketFault from './basket/RecapBasketFault.js'
import RecapBasketTechnical from './basket/RecapBasketTechnical.js'
import RecapBasketThreePoints from './basket/RecapBasketThreePoints.js'
import RecapBasketTwoPoints from './basket/RecapBasketTwoPoints.js'
import RecapBasketFreeThrow from './basket/RecapBasketFreeThrow.js'

//HANDBALL
import RecapHandballStop from './handball/RecapHandballStop.js'
import RecapHandballGoal from './handball/RecapHandballGoal.js'
import RecapHandballPenalty from './handball/RecapHandballPenalty.js'
import RecapHandballYellowCard from './handball/RecapHandballYellowCard.js'
import RecapHandballRedCard from './handball/RecapHandballRedCard.js'
import RecapHandballSuspension from './handball/RecapHandballSuspension.js'
import RecapHandballTimeout from './handball/RecapHandballTimeout.js'
import RecapHandballTurnover from './handball/RecapHandballTurnover.js'

import RecapBasketTimeout from './basket/RecapBasketTimeout.js'
import RecapTotalMinutesPlayed from './recapGeneric/RecapTotalMinutesPlayed.js'
import RecapHandballShootout from './handball/RecapHandballShootout.js'

export const genericGameFacts = [
    {
      id : GAME_FACT_START,
      img : commentaire,
      pos : undefined,
      discipline : 'all',
      recapComponent : RecapStart,
      steps : [
        {
          label: 'Saisissez votre commentaire',
          id: 'comment',
          description: SelectComment,
        }
      ]
    }
  ]
  
const soccerGameFacts = [
    {
      id : GAME_FACT_SOCCER_STOP,
      img : commentaire,
      pos : undefined,
      discipline : 'all',
      recapComponent : RecapSoccerStop,
      steps : [
        {
          label: 'Quelle est la minute de la fin de période ?',
          id: 'timer',
          description: SelectTimer,
        },
        {
          label: 'Et ensuite ?',
          id: 'reason',
          description: SelectReason,
          array : reasonListSoccerStop
        },
        {
          label: 'Saisissez votre commentaire',
          id: 'comment',
          description: SelectComment,
        }
      ]
    },
    {
      id : GAME_FACT_SOCCER_STAR,
      img : btn_star,
      pos : [0, 4],
      show : [0, 1, 2, 3, 4, 6],
      discipline : 'soccer',
      recapComponent : RecapSoccerStar,
      steps : [
        {
          label: 'Quelle équipe a obtenu l\'étoile ?',
          id : 'team',
          description : SelectTeam
        },
        {
          label: 'Quel joueur a obtenu l\'étoile ?',
          id: 'player',
          description: SelectPlayerInTeam,
          filter : 'state[steps[0].id]',
          searchFilter : true,
        },
      ]
    },
    {
      id : GAME_FACT_SOCCER_BUT,
      img : but,
      pos : [0, 0],
      show : [0, 1, 2, 3, 4, 6],
      discipline : 'soccer',
      recapComponent : RecapSoccerBut,
      steps : [
        {
          label: 'Quelle équipe a marqué le but ?',
          id : 'team',
          description : SelectTeam
        },
        {
          label: 'Quel joueur a marqué le but ?',
          id: 'buteur',
          description: SelectPlayerInTeam,
          filter : 'state[steps[0].id]',
          searchFilter : true,
          custoAnswers : [{id : 'csc', value : 'Contre son camp'}]
        },
        {
          label: 'Quelle est la minute du but ?',
          id: 'timer',
          description: SelectTimer,
        },
        {
          label: 'Quel joueur effectue la passe décisive ?',
          id: 'passeur',
          description: SelectPlayerInTeam,
          filter : 'state[steps[0].id]',
          noAnswer : true,
          searchFilter : true
        },
        {
          label: 'Le but a-t-il été validé ?',
          id: 'butSucced',
          description: SelectYesNo,
        },
      ]
    },
    {
      id : GAME_FACT_SOCCER_SHOT,
      img : tir,
      pos : [3, 3],
      show : [0, 1, 2, 3, 4, 6],
      discipline : 'soccer',
      recapComponent : RecapSoccerShot,
      steps : [
        {
          label: 'Quelle équipe a tiré ?',
          id : 'team',
          description : SelectTeam
        },
        {
          label: 'Quel joueur a tiré ?',
          id: 'shoter',
          description: SelectPlayerInTeam,
          filter : 'state[steps[0].id]',
          searchFilter : true,
        },
        {
          label: 'Quelle est la minute du tir ?',
          id: 'timer',
          description: SelectTimer,
        },
        {
          label: 'Qualité du tir ?',
          id: 'reason',
          description: SelectReason,
          array : typeShotListSoccer
        },
      ]
    },
    {
      id : GAME_FACT_SOCCER_SHOOTOUTPENALTY,
      img : btn_soccer_tiraubut,
      pos : [1, 3],
      show : [5],
      discipline : 'soccer',
      recapComponent : RecapSoccerShootoutPenalty,
      steps : [
        {
          label: 'Quelle équipe tir au but ?',
          id : 'team',
          description : SelectTeam
        },
        {
          label: 'Quel joueur frappe le tir au but ?',
          id: 'buteur',
          description: SelectPlayerInTeam,
          filter : 'state[steps[0].id]',
          searchFilter : true
        },
        /*{
          label: 'Quelle est la minute du tir au but ?',
          id: 'timer',
          description: SelectTimer,
        },*/
        {
          label: 'Le joueur a-t-il marqué le tir au but ?',
          id: 'butSucced',
          description: SelectYesNo,
        },
      ]
    },
    {
      id : GAME_FACT_SOCCER_PENALTY,
      img : penalty,
      pos : [1, 0],
      show : [0, 1, 2, 3, 4, 6],
      discipline : 'soccer',
      recapComponent : RecapSoccerPenalty,
      steps : [
        {
          label: 'Quelle équipe obtient un penalty ?',
          id : 'team',
          description : SelectTeam
        },
        {
          label: 'Quel joueur frappe le penalty ?',
          id: 'buteur',
          description: SelectPlayerInTeam,
          filter : 'state[steps[0].id]',
          searchFilter : true
        },
        {
          label: 'Quelle est la minute du penalty ?',
          id: 'timer',
          description: SelectTimer,
        },
        {
          label: 'Le joueur a-t-il marqué le penalty ?',
          id: 'butSucced',
          description: SelectYesNo,
        },
      ]
    },
    {
      id : GAME_FACT_SOCCER_FAULT,
      img : fault,
      pos : [0, 1],
      show : [0, 1, 2, 3, 4, 6],
      discipline : 'soccer',
      recapComponent : RecapSoccerFault,
      steps : [
        {
          label: 'Quelle équipe fait une faute ?',
          id : 'team',
          description : SelectTeam
        },
        {
          label: 'Quel joueur fait la faute ?',
          id: 'player',
          description: SelectPlayerInTeam,
          filter : 'state[steps[0].id]',
          searchFilter : true
        },
        {
          label: 'Quelle est la minute de la faute ?',
          id: 'timer',
          description: SelectTimer,
        },
        {
          label: 'Quel joueur subi la faute ?',
          id: 'opponent',
          description: SelectPlayerInOtherTeam,
          filter : 'state[steps[0].id]',
          searchFilter : true
        },
      ]
    },
    {
      id : GAME_FACT_SOCCER_YELLOWCARD,
      img : yellowcard,
      pos : [0,2],
      show : [0, 1, 2, 3, 4, 6],
      discipline : 'soccer',
      recapComponent : RecapSoccerYellowCard,
      steps : [
          {
            label: 'Quelle équipe reçoit un carton jaune ?',
            id: 'team',
            description: SelectTeam,
            searchFilter : true
          },
          {
            label: 'Quel joueur reçoit un carton jaune ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true,
            isCoachSelectable : true
          },
          {
            label: 'Pour quelle raison ?',
            id: 'reason',
            description: SelectReason,
            array : reasonListSoccer
          },
          {
            label: 'Quelle est la minute du carton jaune ?',
            id: 'timer',
            description: SelectTimer,
          }
        ]
    },
    {
      id : GAME_FACT_SOCCER_REDCARD,
      img : redcard,
      pos : [1,2],
      show : [0, 1, 2, 3, 4, 6],
      discipline : 'soccer',
      recapComponent : RecapSoccerRedCard,
      steps : [
          {
            label: 'Quelle équipe reçoit un carton rouge ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur reçoit un carton rouge ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true,
            isCoachSelectable : true
          },
          {
            label: 'Pour quelle raison ?',
            id: 'reason',
            description: SelectReason,
            array : reasonListSoccerRedCard
          },
          {
            label: 'Quelle est la minute du carton rouge ?',
            id: 'timer',
            description: SelectTimer,
          }
        ]
    },
    {
        id : GAME_FACT_SOCCER_REPLACEMENT,
        img : changement,
        pos : [1,1],
        show : [0, 1, 2, 3, 4, 6],
        discipline : 'soccer',
        recapComponent : RecapSoccerReplacement,
        steps : [
            {
              label: 'Quelle équipe effectue un changement ?',
              id: 'team',
              description: SelectTeam,
            },
            {
              label: 'Quel joueur sort du terrain ?',
              id: 'outplayer',
              description: SelectPlayerInTeam,
              filter : 'state[steps[0].id]',
              searchFilter : true
            },
            {
              label: 'Quelle est la minute du changement ?',
              id: 'timer',
              description: SelectTimer,
            },
            {
              label: 'Quel joueur rentre sur le terrain ?',
              id: 'inplayer',
              description: SelectPlayerInTeam,
              filter : 'state[steps[0].id]',
              searchFilter : true
            }
          ]
    },
    {
      id : GAME_FACT_SOCCER_COMMENT,
      img : commentaire,
      pos : [0,3],
      show : [0, 1, 2, 3, 4, 5, 6],
      discipline : 'soccer',
      recapComponent : RecapSoccerComment,
      steps : [
          {
            label: 'Quelle est la cible du commentaire ?',
            id: 'target',
            description: SelectTeam,
            items : [{id : "other", name : "Autre"}]
          },
          {
            label: 'Quelle est la minute de votre commentaire ?',
            id: 'timer',
            description: SelectTimer,
          },
          {
            label: 'Saisissez votre commentaire',
            id: 'comment',
            description: SelectComment,
          }
        ]
    }
  ]
  
const rugbyGameFacts = [
    {
      id : GAME_FACT_RUGBY_STOP,
      img : commentaire,
      pos : undefined,
      discipline : 'rugby',
      recapComponent : RecapRugbyStop,
      steps : [
        {
          label: 'Quelle est la minute de la fin de période ?',
          id: 'timer',
          description: SelectTimer,
        },
        {
          label: 'Et ensuite ?',
          id: 'reason',
          description: SelectReason,
          array : reasonListRugbyStop
        },
        {
          label: 'Saisissez votre commentaire',
          id: 'comment',
          description: SelectComment,
        }
      ]
    },
      {
        id : GAME_FACT_ESSAI,
        img : essai,
        pos : [0,0],
        show : [0, 1, 2, 3, 4, 6],
        discipline : 'rugby',
        recapComponent : RecapEssai,
        steps : [
            {
              label: 'Quelle équipe a marqué l\'essai ?',
              id: 'team',
              description: SelectTeam,
            },
            {
              label: 'Quel joueur a marqué l\'essai ?',
              id: 'buteur',
              description: SelectPlayerInTeam,
              filter : 'state[steps[0].id]',
              searchFilter : true,
              custoAnswers : [{id : 'edp', value : 'Essai de pénalité'}]
            },
            {
              label: 'Quelle est la minute de l\'essai ?',
              id: 'timer',
              description: SelectTimer,
            }
          ]
    },
    {
      id : GAME_FACT_RUGBY_STAR,
      img : btn_star,
      pos : [1,4],
      show : [0, 1, 2, 3, 4, 6],
      discipline : 'rugby',
      recapComponent : RecapRugbyStar,
      steps : [
          {
            label: 'Quelle équipe a obtenu l\'étoile ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur a obtenu l\'étoile ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true,
          }
        ]
  },
    {
      id : GAME_FACT_TRANSFORMATION,
      img : transformation,
      pos : [1,0],
      show : [0, 1, 2, 3, 4, 6],
      discipline : 'rugby',
      recapComponent : RecapTransformation,
      steps : [
          {
            label: 'Quelle équipe tente la transformation ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur tente la transformation ?',
            id: 'transformer',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true
          },
          {
            label: 'La transformation a-t-elle été réussie ?',
            id: 'transformSucced',
            description: SelectYesNo,
          },
          {
            label: 'Quelle est la minute de la transformation ?',
            id: 'timer',
            description: SelectTimer,
          }
        ]
    },
    {
      id : GAME_FACT_DROP,
      img : drop,
      pos : [1,1],
      show : [0, 1, 2, 3, 4, 6],
      discipline : 'rugby',
      recapComponent : RecapDrop,
      steps : [
          {
            label: 'Quelle équipe tente le drop ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur tente le drop ?',
            id: 'droper',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true
          },
          {
            label: 'Le drop a-t-il été réussi ?',
            id: 'dropSucced',
            description: SelectYesNo,
          },
          {
            label: 'Quelle est la minute du drop ?',
            id: 'timer',
            description: SelectTimer,
          }
        ]
    },
    {
      id : GAME_FACT_PENALITE,
      img : penalite,
      pos : [0, 1],
      show : [0, 1, 2, 3, 4, 6],
      discipline : 'rugby',
      recapComponent : RecapPenality,
      steps : [
          {
            label: 'Quelle équipe tente la penalité ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur tente la pénalité ?',
            id: 'penaliter',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true
          },
          {
            label: 'La pénalité a-t-elle été réussie ?',
            id: 'penalitySucced',
            description: SelectYesNo,
          },
          {
            label: 'Quelle est la minute de la pénalité ?',
            id: 'timer',
            description: SelectTimer,
          }
        ]
    },
    {
      id : GAME_FACT_SHOOTOUTPENALTY,
      img : btn_rugby_tiraubut,
      pos : [1, 4],
      show : [5],
      discipline : 'rugby',
      recapComponent : RecapShootoutPenality,
      steps : [
          {
            label: 'Quelle équipe tir au but ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur frappe le tir au but ?',
            id: 'penaliter',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true
          },
          {
            label: 'Le tir au but est-il réussi ?',
            id: 'penalitySucced',
            description: SelectYesNo,
          },
          /*{
            label: 'Quelle est la minute du tir au but ?',
            id: 'timer',
            description: SelectTimer,
          }*/
        ]
    },
    {
      id : GAME_FACT_YELLOWCARD,
      img : yellowcard,
      pos : [0,3],
      show : [0, 1, 2, 3, 4, 6],
      discipline : 'rugby',
      recapComponent : RecapYellowCard,
      steps : [
          {
            label: 'Quelle équipe reçoit un carton jaune ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur reçoit un carton jaune ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true,
            isCoachSelectable : true
          },
          {
            label: 'Pour quelle raison ?',
            id: 'reason',
            description: SelectReason,
            array : reasonListRugby
          },
          {
            label: 'Quelle est la minute du carton jaune ?',
            id: 'timer',
            description: SelectTimer,
          }
        ]
    },
    {
      id : GAME_FACT_REDCARD,
      img : redcard,
      pos : [1,3],
      show : [0, 1, 2, 3, 4, 6],
      discipline : 'rugby',
      recapComponent : RecapRedCard,
      steps : [
          {
            label: 'Quelle équipe reçoit un carton rouge ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur reçoit un carton rouge ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true,
            isCoachSelectable : true
          },
          {
            label: 'Pour quelle raison ?',
            id: 'reason',
            description: SelectReason,
            array : reasonListRugby
          },
          {
            label: 'Quelle est la minute du carton rouge ?',
            id: 'timer',
            description: SelectTimer,
          }
        ]
    },
    {
      id : GAME_FACT_FAULT,
      img : fault,
      pos : [0,2],
      show : [0, 1, 2, 3, 4, 6],
      discipline : 'rugby',
      recapComponent : RecapFault,
      steps : [
          {
            label: 'Quelle équipe effectue une faute ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur effectue une faute ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true
          },
          {
            label: 'Pour quelle raison ?',
            id: 'reason',
            description: SelectReason,
            array : reasonListRugby
          },
          {
            label: 'Quelle est la minute de la faute ?',
            id: 'timer',
            description: SelectTimer,
          }
        ]
    },
    {
        id : GAME_FACT_REPLACEMENT,
        img : changement,
        pos : [1,2],
        show : [0, 1, 2, 3, 4, 6],
        discipline : 'rugby',
        recapComponent : RecapReplacement,
        steps : [
            {
              label: 'Quelle équipe effectue un changement ?',
              id: 'team',
              description: SelectTeam,
            },
            {
              label: 'Quel joueur sort du terrain ?',
              id: 'outplayer',
              description: SelectPlayerInTeam,
              filter : 'state[steps[0].id]',
              searchFilter : true
            },
            {
              label: 'Pour quelle raison ?',
              id: 'reason',
              description: SelectReason,
              array : reasonListRugbyReplacement
            },
            {
              label: 'Quelle est la minute du changement ?',
              id: 'timer',
              description: SelectTimer,
            },
            {
              label: 'Quel joueur rentre sur le terrain ?',
              id: 'inplayer',
              description: SelectPlayerInTeam,
              filter : 'state[steps[0].id]',
              searchFilter : true
            }
          ]
    },
    {
      id : GAME_FACT_COMMENT,
      img : commentaire,
      pos : [0,4],
      show : [0, 1, 2, 3, 4, 5, 6],
      discipline : 'rugby',
      recapComponent : RecapComment,
      steps : [
          {
            label: 'Quelle est la cible du commentaire ?',
            id: 'target',
            description: SelectTeam,
            items : [{id : "other", name : "Autre"}]
          },
          {
            label: 'Quelle est la minute de votre commentaire ?',
            id: 'timer',
            description: SelectTimer,
          },
          {
            label: 'Saisissez votre commentaire',
            id: 'comment',
            description: SelectComment,
          }
        ]
    }
  ]
  
const basketGameFacts = [
    {
      id : GAME_FACT_BASKET_STOP,
      img : commentaire,
      pos : undefined,
      discipline : 'basket',
      recapComponent : RecapBasketStop,
      steps : [
        {
          label: 'Et ensuite ?',
          id: 'reason',
          description: SelectReason,
          array : reasonListBasketStop
        },
        {
          label: 'Saisissez votre commentaire',
          id: 'comment',
          description: SelectComment,
        }
      ]
    },
    {
      id : GAME_FACT_BASKET_FREETHROW,
      img : btn_basket_lancerfranc,
      pos : [0,0],
      show : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      discipline : 'basket',
      recapComponent : RecapBasketFreeThrow,
      defaultState : {isSucceed : true},
      steps : [
          {
            label: 'Quelle équipe tir lancer franc ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur tir lancer franc ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true
          }
        ]
    },
    {
      id : GAME_FACT_BASKET_TWOPOINTS,
      img : btn_basket_deuxpoints,
      pos : [1,0],
      show : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      discipline : 'basket',
      recapComponent : RecapBasketTwoPoints,
      defaultState : {isSucceed : true},
      steps : [
          {
            label: 'Quelle équipe tir deux points ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur tir deux points ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true
          }
        ]
    },
    {
      id : GAME_FACT_BASKET_THREEPOINTS,
      img : btn_basket_troispoints,
      pos : [0, 1],
      show : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      discipline : 'basket',
      recapComponent : RecapBasketThreePoints,
      defaultState : {isSucceed : true},
      steps : [
          {
            label: 'Quelle équipe tir trois points ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur tir trois points ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true
          }
        ]
    },
    {
      id : GAME_FACT_BASKET_FAULT,
      img : btn_basket_faute,
      pos : [1,1],
      show : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      discipline : 'basket',
      recapComponent : RecapBasketFault,
      steps : [
          {
            label: 'Quelle équipe fait une faute ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur fait une faute ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true
          }
        ]
    },
    {
      id : GAME_FACT_BASKET_TECHNICAL,
      img : btn_basket_technique,
      pos : [0,2],
      show : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      discipline : 'basket',
      recapComponent : RecapBasketTechnical,
      steps : [
          {
            label: 'Quelle équipe fait une faute technique ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur fait une faute technique ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true
          }
        ]
    },
    {
      id : GAME_FACT_BASKET_COMMENT,
      img : commentaire,
      pos : [1,2],
      show : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      discipline : 'basket',
      recapComponent : RecapBasketComment,
      steps : [
          {
            label: 'Quelle est la cible du commentaire ?',
            id: 'target',
            description: SelectTeam,
            items : [{id : "other", name : "Autre"}]
          },
          {
            label: 'Saisissez votre commentaire',
            id: 'comment',
            description: SelectComment,
          }
        ]
    },
    {
      id : GAME_FACT_BASKET_TIMEOUT,
      img : btn_basket_timeout,
      pos : [0,3],
      show : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      discipline : 'basket',
      recapComponent : RecapBasketTimeout,
      steps : [
          {
            label: 'Quelle équipe prend un temps mort ?',
            id: 'team',
            description: SelectTeam,
          }
        ]
    },
    //TODO CHANGE WHEN REPLACEMENT IS NEEDED - for now it's juste import CSV minutes played GF (replacement out)
    {
      id : GAME_FACT_BASKET_REPLACEMENT,
      img : undefined,
      pos : [0, 1],
      show : [],
      discipline : 'basket',
      recapComponent : RecapTotalMinutesPlayed,
      steps : [
        ]
    }
  ]

  export const handballGameFacts = [
    {
      id : GAME_FACT_HANDBALL_STOP,
      img : commentaire,
      pos : undefined,
      discipline : 'handball',
      recapComponent : RecapHandballStop,
      steps : [
        {
          label: 'Quelle est la minute de la fin de période ?',
          id: 'timer',
          description: SelectTimer,
        },
        {
          label: 'Et ensuite ?',
          id: 'reason',
          description: SelectReason,
          array : reasonListHandballStop
        },
        {
          label: 'Saisissez votre commentaire',
          id: 'comment',
          description: SelectComment,
        }
      ]
    },

    {
      id : GAME_FACT_HANDBALL_GOAL,
      img : btn_but_hand,
      imgSucceed: btn_but_hand,
      imgFailed: btn_but_refuse_hand,
      pos : [0, 0],
      show : [0, 1, 2, 3, 4, 5, 6, 7, 10, 11],
      discipline : 'handball',
      recapComponent : RecapHandballGoal,
      steps : [
        {
          label: 'Quelle équipe a marqué le but ?',
          id : 'team',
          description : SelectTeam
        },
        {
          label: 'Quel joueur a marqué le but ?',
          id: 'buteur',
          description: SelectPlayerInTeam,
          filter : 'state[steps[0].id]',
          searchFilter : true,
        },
        {
          label: 'Quelle est la minute du but ?',
          id: 'timer',
          description: SelectTimer,
        },
        {
          label: 'Le but a-t-il été validé ?',
          id: 'butSucced',
          description: SelectYesNo,
        },
      ]
    },

    {
      id : GAME_FACT_HANDBALL_PENALTY,
      img : btn_penalty_hand,
      imgSucceed: btn_penalty_reussi_hand,
      imgFailed: btn_penalty_rate_hand,
      pos : [1, 1],
      show : [0, 1, 2, 3, 4, 5, 6, 7,10, 11],
      discipline : 'handball',
      recapComponent : RecapHandballPenalty,
      steps : [
        {
          label: 'Quelle équipe obtient un penalty ?',
          id : 'team',
          description : SelectTeam
        },
        {
          label: 'Quel joueur frappe le penalty ?',
          id: 'penaliter',
          description: SelectPlayerInTeam,
          filter : 'state[steps[0].id]',
          searchFilter : true
        },
        {
          label: 'Pour quelle raison ?',
          id: 'reason',
          description: SelectReason,
          array : reasonListHandballPenalty
        },
        {
          label: 'Quelle est la minute du penalty ?',
          id: 'timer',
          description: SelectTimer,
        },
        {
          label: 'Le joueur a-t-il marqué le penalty ?',
          id: 'penalitySucced',
          description: SelectYesNo,
        },
      ]
    },

    {
      id : GAME_FACT_HANDBALL_SHOOTOUT,
      img : btn_tir_au_but_hand,
      imgSucceed: btn_tir_au_but_reussi_hand,
      imgFailed: btn_tir_au_but_rate_hand,
      pos : [0, 0],
      show : [8, 9, 10, 11],
      discipline : 'handball',
      recapComponent : RecapHandballShootout,
      steps : [
          {
            label: 'Quelle équipe tir au but ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur frappe le tir au but ?',
            id: 'buteur',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true
          },
          {
            label: 'Le tir au but est-il réussi ?',
            id: 'butSucced',
            description: SelectYesNo,
          },
        ]
    },

    {
      id : GAME_FACT_HANDBALL_YELLOWCARD,
      img : btn_avertissement_handball,
      pos : [1,2],
      show : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      discipline : 'handball',
      recapComponent : RecapHandballYellowCard,
      steps : [
          {
            label: 'Quelle équipe reçoit un avertissement ?',
            id: 'team',
            description: SelectTeam,
            searchFilter : true
          },
          {
            label: 'Quel joueur reçoit un avertissement ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true,
            isCoachSelectable : true
          },
          {
            label: 'Pour quelle raison ?',
            id: 'reason',
            description: SelectReason,
            array : reasonListHandballYellowCard
          },
          {
            label: 'Quelle est la minute de l’avertissement ?',
            id: 'timer',
            description: SelectTimer,
          }
        ]
    },

    {
      id : GAME_FACT_HANDBALL_REDCARD,
      img : btn_disqualification_hand,
      pos : [1,2],
      show : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      discipline : 'handball',
      recapComponent : RecapHandballRedCard,
      steps : [
          {
            label: 'Quelle équipe reçoit une disqualification ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur reçoit une disqualification ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true,
            isCoachSelectable : true
          },
          {
            label: 'Pour quelle raison ?',
            id: 'reason',
            description: SelectReason,
            array : reasonListHandballRedCard
          },
          {
            label: 'Quelle est la minute de la disqualification ?',
            id: 'timer',
            description: SelectTimer,
          }
        ]
    },

    {
      id : GAME_FACT_HANDBALL_TWOMIN_SUSPENSION,
      img : btn_suspension_handball,
      pos : [0,1],
      show : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      discipline : 'handball',
      recapComponent : RecapHandballSuspension,
      steps : [
          {
            label: 'Quelle équipe reçoit une exclusion ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur reçoit une exclusion ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true
          },
          {
            label: 'Pour quelle raison ?',
            id: 'reason',
            description: SelectReason,
            array : reasonListHandballTwoMinSuspension
          }
        ]
    },

    {
      id : GAME_FACT_HANDBALL_TIMEOUT,
      img : btn_timeout_handball,
      pos : [0,4],
      show : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      discipline : 'handball',
      recapComponent : RecapHandballTimeout,
      steps : [
          {
            label: 'Quelle équipe prend un temps mort ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'À quelle minute du match ?',
            id: 'timer',
            description: SelectTimer,
          }
        ]
    },

    {
      id : GAME_FACT_HANDBALL_TURNOVER,
      img : btn_turnover_handball,
      pos : [0,4],
      show : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      discipline : 'handball',
      recapComponent : RecapHandballTurnover,
      steps : [
          {
            label: 'Quelle équipe a perdu la balle ?',
            id: 'team',
            description: SelectTeam,
          },
          {
            label: 'Quel joueur a perdu la balle ?',
            id: 'player',
            description: SelectPlayerInTeam,
            filter : 'state[steps[0].id]',
            searchFilter : true
          },
          {
            label: 'Quelle est la raison de la perte de balle ?',
            id: 'reason',
            description: SelectReason,
            array : reasonListHandballTurnover
          },
          {
            label: 'À quelle minute s’est produite la perte de balle ?',
            id: 'timer',
            description: SelectTimer,
          }
        ]
    },
    //TODO CHANGE WHEN REPLACEMENT IS NEEDED - for now it's juste import CSV minutes played GF (replacement out)
    {
      id : GAME_FACT_HANDBALL_REPLACEMENT,
      img : undefined,
      pos : [0, 1],
      show : [],
      discipline : 'handball',
      recapComponent : RecapTotalMinutesPlayed,
      steps : [
        ]
    },
    {
      id : GAME_FACT_COMMENT,
      img : commentaire,
      pos : [1,4],
      show : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      discipline : 'handball',
      recapComponent : RecapComment,
      steps : [
          {
            label: 'Quelle est la cible du commentaire ?',
            id: 'target',
            description: SelectTeam,
            items : [{id : "other", name : "Autre"}]
          },
          {
            label: 'Quelle est la minute de votre commentaire ?',
            id: 'timer',
            description: SelectTimer,
          },
          {
            label: 'Saisissez votre commentaire',
            id: 'comment',
            description: SelectComment,
          }
        ]
    }


    
  ]


export default [
    ...rugbyGameFacts, 
    ...soccerGameFacts,
    ...basketGameFacts,
    ...handballGameFacts,
    ...genericGameFacts
  ]